import {View} from 'react-native'
import {msg} from '@lingui/macro'
import {useLingui} from '@lingui/react'

import {type MarkdownHeader} from '#/lib/markdown/extractHeaders'
import {atoms as a, useTheme} from '#/alf'
import {Divider} from '#/components/Divider'
import {Text} from '#/components/Typography'

interface TableOfContentsProps {
  headers: MarkdownHeader[]
}

export function TableOfContents({headers}: TableOfContentsProps) {
  const t = useTheme()
  const {_} = useLingui()

  if (headers.length === 0) {
    return null
  }

  return (
    <>
      <View style={[a.gap_sm, {paddingBottom: 2}]}>
        <View style={[a.flex_row, a.align_center, a.gap_xs]}>
          <Text
            style={[
              a.flex_1,
              a.text_sm,
              a.font_bold,
              t.atoms.text_contrast_medium,
            ]}>
            {_(msg`Table of Contents`)}
          </Text>
        </View>

        <View style={[a.gap_xs]}>
          {headers.map((header, index) => {
            // Only show H1 and H2 headers in the TOC for cleaner navigation
            if (header.level > 2) {
              return null
            }

            const isH2 = header.level === 2
            const paddingLeft = isH2 ? 12 : 0

            return (
              <View key={`${header.id}-${index}`}>
                <View style={[a.py_sm, {paddingLeft}]}>
                  <Text
                    style={[
                      a.text_sm,
                      isH2 ? a.font_normal : a.font_bold,
                      t.atoms.text_contrast_high,
                      a.leading_snug,
                    ]}
                    numberOfLines={2}>
                    {header.text}
                  </Text>
                </View>
                {index < headers.filter(h => h.level <= 2).length - 1 && (
                  <View style={{paddingLeft}}>
                    <Divider />
                  </View>
                )}
              </View>
            )
          })}
        </View>
      </View>
      <Divider />
    </>
  )
}
